import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=2ecdee7e&scoped=true"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=2ecdee7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecdee7e",
  null
  
)

export default component.exports